import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Play16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M1.25 2.641C1.24999 2.35732 1.3247 2.07848 1.46687 1.83169C1.60904 1.58489 1.81381 1.37857 2.06119 1.23289C2.30857 1.0872 2.59011 1.00711 2.87833 1.00045C3.16645 0.993791 3.45164 1.06087 3.70561 1.19485L13.8702 6.55371C14.136 6.69395 14.3584 6.9026 14.5133 7.15728C14.6682 7.41195 14.75 7.7032 14.75 8C14.75 8.2968 14.6682 8.58805 14.5133 8.84272C14.3584 9.09739 14.1362 9.30595 13.8704 9.44619L3.70563 14.8051C3.45167 14.9391 3.16646 15.0062 2.87833 14.9995C2.59011 14.9929 2.30857 14.9128 2.06119 14.7671C1.81381 14.6214 1.60904 14.4151 1.46687 14.1683C1.3247 13.9215 1.24998 13.6427 1.25 13.359V2.641ZM2.71678 2.641V13.359C2.71677 13.3932 2.72578 13.4268 2.74288 13.4565C2.75999 13.4862 2.78464 13.511 2.81442 13.5286C2.84419 13.5461 2.87808 13.5557 2.91277 13.5565C2.94746 13.5573 2.98178 13.5493 3.01236 13.5331L13.1773 8.1741C13.2093 8.1572 13.2362 8.13198 13.2547 8.10143C13.2734 8.07078 13.2832 8.03573 13.2832 8C13.2832 7.96428 13.2734 7.92922 13.2547 7.89856C13.2361 7.86797 13.2094 7.84286 13.1774 7.82598L3.01267 2.46702C2.98199 2.45083 2.94736 2.44265 2.91277 2.44345C2.87808 2.44426 2.84419 2.4539 2.81442 2.47143C2.78464 2.48897 2.75999 2.5138 2.74288 2.54351C2.72578 2.5732 2.71677 2.60683 2.71678 2.641Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
